import axios from "axios";
export default async function() {
  let arr = [],
    obj = {};

  const { data } = await axios.get("/cityCode/list/open");
  data.code === 0 ? (arr = data.data) : [];
  if (arr.length) {
    arr.forEach((item) => {
      obj[item.code] = item.areaName;
    });
  }
  return [obj, arr];
}
